<template>
  <!-- If route has no children -->
  <VListTile
    v-if="incentive || route.children === undefined"
    :to="routeTarget"
    :disabled="disabled"
    @mouseenter.native="onMouseEnter($event, route)"
    @mouseleave.native="onMouseLeave"
  >
    <VListTileAction class="action-centered">
      <KmIcon :name="route.meta.icon" />
    </VListTileAction>
    <VListTileContent>
      <VListTileTitle>
        {{ title }}
      </VListTileTitle>
    </VListTileContent>
  </VListTile>
  <!-- if route has children -->
  <VListGroup v-else noAction>
    <VListTile
      slot="activator"
      :to="routeTarget"
      @mouseenter.native="onMouseEnter($event, route)"
      @mouseleave.native="onMouseLeave"
    >
      <VListTileAction class="action-centered">
        <KmIcon :name="route.meta.icon" />
      </VListTileAction>
      <VListTileContent>{{ title }}</VListTileContent>
    </VListTile>
    <VListTile
      v-for="childRoute in route.children"
      :key="childRoute.name"
      :to="{ name: childRoute.name }"
      class="child-link"
      @mouseenter.native="onMouseEnter($event, childRoute)"
      @mouseleave.native="onMouseLeave"
    >
      <VListTileAction>
        <KmIcon :name="childRoute.meta.icon" />
      </VListTileAction>
      <VListTileContent>
        <VListTileTitle>
          {{ childRoute.meta.title }}
        </VListTileTitle>
      </VListTileContent>
    </VListTile>
  </VListGroup>
</template>

<script>
import KmIcon from '@/components/KmIcon'
import { FEATURE_INCENTIVE_PAGE } from '@/router'

export default {
  name: 'NavbarRouteItem',
  components: {
    KmIcon,
  },
  props: {
    route: {
      type: Object,
      required: true,
    },
    extra: {
      type: Object,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    incentive: Object,
  },
  computed: {
    title() {
      return this.incentive ? this.incentive.title : this.route.meta.title
    },
    routeTarget() {
      if (this.incentive) {
        return {
          name: FEATURE_INCENTIVE_PAGE,
          params: {
            incentiveId: this.incentive.id,
            id: this.$route.params.id,
            appType: this.$route.params.appType,
          },
        }
      }
      return { name: this.route.name, ...this.extra }
    },
  },
  methods: {
    onMouseEnter(event, route) {
      this.$emit('hover-route', { element: event.target, route, incentive: this.incentive })
    },
    onMouseLeave() {
      this.$emit('leave-route')
    },
  },
}
</script>

<style lang="postcss" scoped>
.v-list__tile__title {
  display: flex;
  justify-content: space-between;
}
/* Make sure the text container doesn't shrink, so the 'arrow down' icon is pushed outside the
navbar when it is closed */
.v-list__group__header > div {
  flex-shrink: 0 !important;
}
</style>
